import { getName } from "country-list";

export const eventTypes = {
  HOLIDAY: "HOLIDAY",
  EVENT: "EVENT",
};

const createHolidayEvent = (event, entity, item) => {
  return {
    id: event.data?.id,
    title: event.data.name[0].text,
    subTitle: getName(entity?.country),
    label: "Holiday",
    start: new Date(event.data?.date?.iso),
    end: new Date(event.data?.date?.iso),
    type: eventTypes.HOLIDAY,
    filterType: event.type,
    country: entity?.country,
    oneliner: event.data?.oneliner[0]?.text,
    totalCount: item.totalCount,
    backgroundColor: "#F5F5F5",
    color: "#212121",
  };
};

const createMilestoneAndTaskEvent = (event, item) => {
  return {
    title: event.data?.name,
    status: event.data?.statusData,
    label: event.data?.serviceData.name,
    subTitle: event.data?.owner,
    start: new Date(event.data?.due_date),
    end: new Date(event.data?.due_date),
    type: eventTypes.EVENT,
    backgroundColor: event.data?.serviceData.secondary_color,
    color: event.data?.serviceData.primary_color,
    process: event.data?.processData?.id,
    id: event.type === "Milestones" ? event.data?.id : event.data?.milestone,
    filterType: event.type,
    totalCount: item.totalCount,
    due_date_utc: new Date(event.data?.due_date),
    processData: event.data?.processData,
  };
};

export const convertDataToCalendarEvents = (data = [], entity) => {
  const events = [];
  data.forEach((item) => {
    item.items.forEach((event) => {
      if (event) {
        let eventData = {};
        if (event.type === "Holidays") {
          eventData = createHolidayEvent(event, entity, item);
        } else {
          eventData = createMilestoneAndTaskEvent(event, item);
        }
        events.push(eventData);
      }
    });
  });

  return events;
};
